import React from 'react';
import { FeedbackType } from '../types';

type FeedbackTextProps = {
    textfieldFeedback: string;
    setTextfieldFeedback: (e) => void;
    type: import('../types').FeedbackType;
};

const FeedbackText: React.FC<FeedbackTextProps> = (props) => {
    const { textfieldFeedback, setTextfieldFeedback, type } = props;

    return (
        <>
            <h3 className="text-center u-t2 mb-32">
                {type === FeedbackType.Forhandler &&
                    'Hva tenker du om at bedrifter annonserer på FINN torget?'}
                {type === FeedbackType.Keyword &&
                    'Hvor bra gjorde vi det idag?'}
            </h3>
            <div className="input input--text">
                <input
                    type="text"
                    maxLength={280}
                    onChange={(e) => setTextfieldFeedback(e.target.value)}
                    value={textfieldFeedback}
                    autoFocus
                />
                <div className="input__sub-text">
                    <span className="input__sub-text__text-hint">
                        {textfieldFeedback.length}/280 tegn
                    </span>
                </div>
            </div>
        </>
    );
};

export default FeedbackText;
